export const GTM_DATA_LAYER = typeof window !== 'undefined' ? window.dataLayer || [] : [];